import { render, staticRenderFns } from "./EstimageMessageDetail.vue?vue&type=template&id=1b691130"
import script from "./EstimageMessageDetail.vue?vue&type=script&lang=js"
export * from "./EstimageMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./EstimageMessageDetail.vue?vue&type=style&index=0&id=1b691130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports